<template>
	<div grey-back full-height>

		<v-toolbar dark flat fixed nopadding>
      		<v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
      		<v-toolbar-title>Security</v-toolbar-title>
    	</v-toolbar>

	    <div class="hasToolbar">
	    	
	    	<div class="switches" white-background>
	    		<v-switch label="App Lock" v-model="security.appLock" @change="fn_toggleAppLock" nomargin></v-switch>
	    	</div>

	    </div>

	</div>
</template>

<script>

	export default{
		data(){
			return{
				security:{"appLock":false}
			}
		},
		methods:{
			fn_goBack: function(){
				this.$router.go(-1);
			},

			fn_toggleAppLock: function(value){
				let toggleValue = value ? 1 : 0;
				let self = this;
	          	this.getData("ToggleAppLock", toggleValue, 
	              	{
	                  	onSuccess: function(response){
	                    	console.log(response);
	                    	let status = JSON.parse(response);
	                    	if(status == 1){
	                    		self.showToast("App Lock enabled");
	                    	}
	                    	else{
	                    		self.showToast("App Lock disabled");
	                    		self.security.appLock = false;
	                    	}
	                  	}, 
	                  	onError: function(error){
	                      	console.log(error);
	                  	}
	              	}
	          	);
			},

			fn_appLockStatus: function(){
				let self = this;
	          	this.getData("AppLockStatus", null, 
	              	{
	                  	onSuccess: function(response){
	                    	console.log(response);
	                    	let status = JSON.parse(response);
	                    	self.security.appLock = status == 1 ? true : false;
	                  	}, 
	                  	onError: function(error){
	                      	console.log(error);
	                  	}
	              	}
	          	);
			}
		},


	  	mounted: function(){
	  		window.js_globals.fn_onBackPress = this.fn_goBack;
	  		this.fn_appLockStatus();
	  	}
	}
</script>


// WEBPACK FOOTER //
// src/components/settings/security/security_options.vue